import { graphql } from "@/gql";

export const updateWorkOrderJobOpeningOfferMutation = graphql(`
  mutation UpdateWorkOrderJobOpeningOffer(
    $id: ID!
    $input: UpdateWorkOrderJobOpeningOfferInput!
  ) {
    updateWorkOrderJobOpeningOffer(id: $id, input: $input) {
      id
      status
    }
  }
`);

export const createWorkOrderJobOpeningOfferMutation = graphql(`
  mutation CreateWorkOrderJobOpeningOffer(
    $input: CreateWorkOrderJobOpeningOfferInput!
  ) {
    createWorkOrderJobOpeningOffer(input: $input) {
      id
      status
    }
  }
`);

export const createWorkOrderJobOpeningOffersMutation = graphql(`
  mutation CreateWorkOrderJobOpeningOffers(
    $input: CreateWorkOrderJobOpeningOffersInput!
  ) {
    createWorkOrderJobOpeningOffers(input: $input)
  }
`);

export const deleteWorkOrderJobOpeningOfferMutation = graphql(`
  mutation DeleteWorkOrderJobOpeningOffer($id: ID!) {
    deleteWorkOrderJobOpeningOffer(id: $id) {
      id
    }
  }
`);
